type Row = {
  /** Standalone token */
  tok: string;
  /** Format token */
  ftok: string;
  /** Description */
  desc: string;
  /** Example */
  ex: string;
};

export const FORMATTING_TOKENS_ROWS: Row[] = [
  { tok: 'S', ftok: '', desc: 'millisecond, no padding', ex: '54' },
  { tok: 'SSS', ftok: '', desc: 'millisecond, padded to 3', ex: '054' },
  {
    tok: 'u',
    ftok: '',
    desc: 'fractional seconds, functionally identical to SSS',
    ex: '054',
  },
  {
    tok: 'uu',
    ftok: '',
    desc: 'fractional seconds, between 0 and 99, padded to 2',
    ex: '05',
  },
  {
    tok: 'uuu',
    ftok: '',
    desc: 'fractional seconds, between 0 and 9',
    ex: '0',
  },
  { tok: 's', ftok: '', desc: 'second, no padding', ex: '4' },
  { tok: 'ss', ftok: '', desc: 'second, padded to 2 padding', ex: '04' },
  { tok: 'm', ftok: '', desc: 'minute, no padding', ex: '7' },
  { tok: 'mm', ftok: '', desc: 'minute, padded to 2', ex: '07' },
  { tok: 'h', ftok: '', desc: 'hour in 12-hour time, no padding', ex: '1' },
  { tok: 'hh', ftok: '', desc: 'hour in 12-hour time, padded to 2', ex: '01' },
  { tok: 'H', ftok: '', desc: 'hour in 24-hour time, no padding', ex: '9' },
  { tok: 'HH', ftok: '', desc: 'hour in 24-hour time, padded to 2', ex: '13' },
  { tok: 'Z', ftok: '', desc: 'narrow offset', ex: '+5' },
  { tok: 'ZZ', ftok: '', desc: 'short offset', ex: '+05:00' },
  { tok: 'ZZZ', ftok: '', desc: 'techie offset', ex: '+0500' },
  { tok: 'ZZZZ', ftok: '', desc: 'abbreviated named offset', ex: 'EST' },
  {
    tok: 'ZZZZZ',
    ftok: '',
    desc: 'unabbreviated named offset',
    ex: 'Eastern Standard Time',
  },
  { tok: 'z', ftok: '', desc: 'IANA zone', ex: 'America/New_York' },
  { tok: 'a', ftok: '', desc: 'meridiem', ex: 'AM' },
  { tok: 'd', ftok: '', desc: 'day of the month, no padding', ex: '6' },
  { tok: 'dd', ftok: '', desc: 'day of the month, padded to 2', ex: '06' },
  {
    tok: 'c',
    ftok: 'E',
    desc: 'day of the week, as number from 1-7 (Monday is 1, Sunday is 7)',
    ex: '3',
  },
  {
    tok: 'ccc',
    ftok: 'EEE',
    desc: 'day of the week, as an abbreviate localized string',
    ex: 'Wed',
  },
  {
    tok: 'cccc',
    ftok: 'EEEE',
    desc: 'day of the week, as an unabbreviated localized string',
    ex: 'Wednesday',
  },
  {
    tok: 'ccccc',
    ftok: 'EEEEE',
    desc: 'day of the week, as a single localized letter',
    ex: 'W',
  },
  { tok: 'L', ftok: 'M', desc: 'month as an unpadded number', ex: '8' },
  { tok: 'LL', ftok: 'MM', desc: 'month as a padded number', ex: '08' },
  {
    tok: 'LLL',
    ftok: 'MMM',
    desc: 'month as an abbreviated localized string',
    ex: 'Aug',
  },
  {
    tok: 'LLLL',
    ftok: 'MMMM',
    desc: 'month as an unabbreviated localized string',
    ex: 'August',
  },
  {
    tok: 'LLLLL',
    ftok: 'MMMMM',
    desc: 'month as a single localized letter',
    ex: 'A',
  },
  { tok: 'y', ftok: '', desc: 'year, unpadded', ex: '2014' },
  { tok: 'yy', ftok: '', desc: 'two-digit year', ex: '14' },
  {
    tok: 'yyyy',
    ftok: '',
    desc: 'four- to six- digit year, pads to 4',
    ex: '2014',
  },
  { tok: 'G', ftok: '', desc: 'abbreviated localized era', ex: 'AD' },
  {
    tok: 'GG',
    ftok: '',
    desc: 'unabbreviated localized era',
    ex: 'Anno Domini',
  },
  { tok: 'GGGGG', ftok: '', desc: 'one-letter localized era', ex: 'A' },
  { tok: 'kk', ftok: '', desc: 'ISO week year, unpadded', ex: '14' },
  { tok: 'kkkk', ftok: '', desc: 'ISO week year, padded to 4', ex: '2014' },
  { tok: 'W', ftok: '', desc: 'ISO week number, unpadded', ex: '32' },
  { tok: 'WW', ftok: '', desc: 'ISO week number, padded to 2', ex: '32' },
  { tok: 'ii', ftok: '', desc: 'Local week year, unpadded', ex: '14' },
  { tok: 'iiii', ftok: '', desc: 'Local week year, padded to 4', ex: '2014' },
  { tok: 'n', ftok: '', desc: 'Local week number, unpadded', ex: '32' },
  { tok: 'nn', ftok: '', desc: 'Local week number, padded to 2', ex: '32' },
  { tok: 'o', ftok: '', desc: 'ordinal (day of year), unpadded', ex: '218' },
  {
    tok: 'ooo',
    ftok: '',
    desc: 'ordinal (day of year), padded to 3',
    ex: '218',
  },
  { tok: 'q', ftok: '', desc: 'quarter, no padding', ex: '3' },
  { tok: 'qq', ftok: '', desc: 'quarter, padded to 2', ex: '03' },
  { tok: 'D', ftok: '', desc: 'localized numeric date', ex: '9/4/2017' },
  {
    tok: 'DD',
    ftok: '',
    desc: 'localized date with abbreviated month',
    ex: 'Aug 6, 2014',
  },
  {
    tok: 'DDD',
    ftok: '',
    desc: 'localized date with full month',
    ex: 'August 6, 2014',
  },
  {
    tok: 'DDDD',
    ftok: '',
    desc: 'localized date with full month and weekday',
    ex: 'Wednesday, August 6, 2014',
  },
  { tok: 't', ftok: '', desc: 'localized time', ex: '9:07 AM' },
  {
    tok: 'tt',
    ftok: '',
    desc: 'localized time with seconds',
    ex: '1:07:04 PM',
  },
  {
    tok: 'ttt',
    ftok: '',
    desc: 'localized time with seconds and abbreviated offset',
    ex: '1:07:04 PM EDT',
  },
  {
    tok: 'tttt',
    ftok: '',
    desc: 'localized time with seconds and full offset',
    ex: '1:07:04 PM Eastern Daylight Time',
  },
  { tok: 'T', ftok: '', desc: 'localized 24-hour time', ex: '13:07' },
  {
    tok: 'TT',
    ftok: '',
    desc: 'localized 24-hour time with seconds',
    ex: '13:07:04',
  },
  {
    tok: 'TTT',
    ftok: '',
    desc: 'localized 24-hour time with seconds and abbreviated offset',
    ex: '13:07:04 EDT',
  },
  {
    tok: 'TTTT',
    ftok: '',
    desc: 'localized 24-hour time with seconds and full offset',
    ex: '13:07:04 Eastern Daylight Time',
  },
  {
    tok: 'f',
    ftok: '',
    desc: 'short localized date and time',
    ex: '8/6/2014, 1:07 PM',
  },
  {
    tok: 'ff',
    ftok: '',
    desc: 'less short localized date and time',
    ex: 'Aug 6, 2014, 1:07 PM',
  },
  {
    tok: 'fff',
    ftok: '',
    desc: 'verbose localized date and time',
    ex: 'August 6, 2014, 1:07 PM EDT',
  },
  {
    tok: 'ffff',
    ftok: '',
    desc: 'extra verbose localized date and time',
    ex: 'Wednesday, August 6, 2014, 1:07 PM Eastern Daylight Time',
  },
  {
    tok: 'F',
    ftok: '',
    desc: 'short localized date and time with seconds',
    ex: '8/6/2014, 1:07:04 PM',
  },
  {
    tok: 'FF',
    ftok: '',
    desc: 'less short localized date and time with seconds',
    ex: 'Aug 6, 2014, 1:07:04 PM',
  },
  {
    tok: 'FFF',
    ftok: '',
    desc: 'verbose localized date and time with seconds',
    ex: 'August 6, 2014, 1:07:04 PM EDT',
  },
  {
    tok: 'FFFF',
    ftok: '',
    desc: 'extra verbose localized date and time with seconds',
    ex: 'Wednesday, August 6, 2014, 1:07:04 PM Eastern Daylight Time',
  },
  { tok: 'X', ftok: '', desc: 'unix timestamp in seconds', ex: '1407287224' },
  {
    tok: 'x',
    ftok: '',
    desc: 'unix timestamp in milliseconds',
    ex: '1407287224054',
  },
];
